<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Plaka</label>
            <v-validator :errors="errors" parameter="VehiclePlateId" :watch="plate">
                <v-select-list v-model="plate" :options="plates" label="PlateValue" placeholder="Plaka Seçiniz"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1" v-if="requireReason">
            <label class="form-label">Değişim Nedeni</label>
            <v-validator :errors="errors" parameter="PlateRemoveReason" :watch="value.PlateRemoveReason">
                <textarea class="form-control resize-none" rows="3" placeholder="Değişim Nedeni" v-model="value.PlateRemoveReason"></textarea>
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    components:{
    },
    props:{
        value:Object,
        plates:Array,
        errors:Object
    },
    data(){
        return{
            requireReason:false,
        }
    },
    watch:{
        plate(nevV,oldV){
            if(nevV != oldV){
                if(this.value.OldVehiclePlateId != this.plate.Id){
                    this.requireReason = true
                }else{
                    this.requireReason = false
                    this.value.PlateRemoveReason = null
                }
            }
        }
    },
    computed:{
        plate:{
            get:function(){
                return this.plates.find(s=>s.Id==this.value.VehiclePlateId)
            },
            set:function(value){
                this.value.VehiclePlateId = value?.Id || this.value.VehiclePlateId
            }
        }
    }
}
</script>

<style lang="scss">
</style>